export default __webpack_public_path__ + "static/media/report-inspection-detail.f6c09e70.svg";